import api from "./axiosInstance";

/**
 * Step 1 – School Details (already exists for you)
 */
export const saveSchoolDetails = (formData) => {
  return api.post(
    "/partner/register/school-details",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

/**
 * Step 2 – Admin + Instructor Details
 */
export const saveAdminInstructorDetails = (formData) => {
  return api.post(
    "/partner/register/admin-instructor-details",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
export const updateAdminInstructorDetails = (formData) => {
  return api.patch(
    "/partner/register/update-admin-instructor-details",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const saveDocuments = (formData) => {
  return api.post(
    "/partner/register/upload-documents",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
export const updateDocuments = (formData) => {
  return api.patch(
    "/partner/register/update-documents",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

/**
 * (Optional later)
 * Get saved admin + instructor data
 */
export const getAdminInstructorDetails = (registrationId) => {
  return api.get(
    `/partner/register/admin-instructor-details/${registrationId}`
  );
};

export const partnerRegister = (data) => {
  return api.post(
    "/partner/register/complete",
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};
export const partnerLogin = (email, password) => {
  return api.post("/partner/login", {
    email,
    password
  });
};
export const forgotPassword = (email) => {
  return api.post(`/partner/forgot-password`, { email });
};

export const verifyResetCode = (email, code) => {
  return api.post(`/partner/verify-reset-code`, { email, code });
}
export const resetPassword = (email, code, newPassword) => {
  return api.post(`/partner/reset-password`, { email, code, newPassword });
}
export const fetchInvite = (token) => {
  return api.get(`/invite/${token}`);
}
export const setPassword = (email, token, password) => {
  return api.post(`/invite/set-password`, { email, token, password });
}
export const getProfile = () => api.get("/partner/profile");

export const updatePersonalInfo = (data) =>
  api.put("/partner/profile/personal", data);

export const updateSchoolDetails = (data) =>
  api.put("/partner/profile/school", data);

export const submitForApproval = () =>
  api.post("/partner/profile/submit-approval");

export const updateBankDetails = (data) =>
  api.put("/partner/profile/bank", data);

export const addStaffFromDashboard = (formData) => {
  return api.post(
    "/partner/dashboard/staff",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const getStaff = () => api.get("/partner/dashboard/staff");

export const deleteStaff = (id) => api.delete(`/partner/dashboard/staff/${id}`);

export const updateStaff = (id, formData) =>
  api.put(`/partner/dashboard/staff/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const createEvent = (formData) =>
  api.post("/partner/events", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const getEvents = () => api.get("/partner/events");

export const getEvent = (id) => api.get(`/partner/events/${id}`);

export const deleteEvent = (id) => api.delete(`/partner/events/${id}`);

export const updateEvent = (id, formData) =>
  api.put(`/partner/events/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// ─── Add these to your existing partnerService.js ────────────────────────────

export const createActivity = (formData) =>
  api.post("/partner/activities", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const getActivities = () => api.get("/partner/activities");

export const getActivity = (id) => api.get(`/partner/activities/${id}`);

export const deleteActivity = (id) => api.delete(`/partner/activities/${id}`);

export const updateActivity = (id, formData) =>
  api.put(`/partner/activities/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const createClass = (formData) =>
  api.post("/partner/classes", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const getClasses = () => api.get("/partner/classes");

export const getClass = (id) => api.get(`/partner/classes/${id}`);

export const updateClass = (id, formData) =>
  api.put(`/partner/classes/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deleteClass = (id) => api.delete(`/partner/classes/${id}`);

/* ─────────────────────────────────────────────────────────────
   Add these to your existing partner axios service file
   (wherever you keep calls like getProfile, getStaff, etc.)
───────────────────────────────────────────────────────────── */


export const getPartnerReviews = () =>
  api.get("/partner/reviews");

export const updateReviewStatus = (reviewId, status, source = "class") =>
  api.patch(`/partner/reviews/${reviewId}/status`, { status, source });

export const replyToReview = (reviewId, reply_text, source = "class") =>
  api.post(`/partner/reviews/${reviewId}/reply`, { reply_text, source });

export const getEnrollments = () =>
  api.get("/partner/enrollments");
 
export const getEnrollment = (id) =>
  api.get(`/partner/enrollments/${id}`);
 
export const updateEnrollmentStatus = (id, booking_status) =>
  api.patch(`/partner/enrollments/${id}/status`, { booking_status });

export const getRefunds = () =>
  api.get("/partner/refunds");
 
export const getRefund = (id) =>
  api.get(`/partner/refunds/${id}`);
 
export const respondToRefund = (id, status, partner_response = "") =>
  api.patch(`/partner/refunds/${id}/respond`, { status, partner_response });


export const getHolidays    = ()                        => api.get("/partner/holidays");
export const createHoliday  = (data)                    => api.post("/partner/holidays", data);
export const updateHoliday  = (id, data)                => api.put(`/partner/holidays/${id}`, data);
export const deleteHoliday  = (id)                      => api.delete(`/partner/holidays/${id}`);

/* Report Issues */
export const getReports      = ()                              => api.get("/partner/reports");
export const getReport       = (id)                            => api.get(`/partner/reports/${id}`);
export const respondToReport = (id, status, admin_response="") =>
  api.patch(`/partner/reports/${id}/respond`, { status, admin_response });


export const getEnrolledChildren = (classId = null) =>
  api.get("/partner/child-report/children", { params: classId ? { classId } : {} });

export const getChildReport = ({ classId, childId, startDate, endDate }) =>
  api.get("/partner/child-report", { params: { classId, childId, startDate, endDate } });

/* ── Attendance ── */
export const getAttendance   = (classId, date)       => api.get("/partner/child-data/attendance", { params: { classId, date } });
export const saveAttendance  = (data)                => api.post("/partner/child-data/attendance", data);
export const deleteAttendance = (id)                 => api.delete(`/partner/child-data/attendance/${id}`);

/* ── Assignments ── */
export const getAssignments    = (classId, childId)  => api.get("/partner/child-data/assignments", { params: { classId, childId } });
export const createAssignment  = (data)              => api.post("/partner/child-data/assignments", data);
export const updateAssignment  = (id, data)          => api.put(`/partner/child-data/assignments/${id}`, data);
export const deleteAssignment  = (id)                => api.delete(`/partner/child-data/assignments/${id}`);

/* ── Behavior ── */
export const getBehavior       = (classId, childId)  => api.get("/partner/child-data/behavior", { params: { classId, childId } });
export const createBehavior    = (data)              => api.post("/partner/child-data/behavior", data);
export const updateBehavior    = (id, data)          => api.put(`/partner/child-data/behavior/${id}`, data);
export const deleteBehavior    = (id)                => api.delete(`/partner/child-data/behavior/${id}`);

/* ── Incidents ── */
export const getIncidents      = (classId, childId)  => api.get("/partner/child-data/incidents", { params: { classId, childId } });
export const createIncident    = (data)              => api.post("/partner/child-data/incidents", data);
export const updateIncident    = (id, data)          => api.put(`/partner/child-data/incidents/${id}`, data);
export const deleteIncident    = (id)                => api.delete(`/partner/child-data/incidents/${id}`);

/* ── Account ── */
export const changePartnerPassword = (data) => api.put("/partner/change-password", data);

/* ── Notification Preferences ── */
export const getPartnerNotifPrefs   = ()       => api.get("/partner/notification-preferences");
export const updatePartnerNotifPrefs = (prefs) => api.put("/partner/notification-preferences", prefs);

export const partnerSocialLogin = (idToken, provider) => {
  return api.post(`/partner/social/${provider}`, { idToken });
};